function ShipmentTitle({
  id,
  className = "",
  number,
  po = null,
  customerName,
  note = null,
  listRowClickable = false,
  showId = true,
  ...rest
}) {
  const firstLineClassName = listRowClickable
    ? "text-sm text-sky-600"
    : "font-semibold text-sm";

  const secondLineClassName = listRowClickable
    ? "break-all text-base font-semibold"
    : "break-all";
  const customerLineClassName = listRowClickable
    ? "font-semibold"
    : "opacity-70";

  return (
    <div className={`flex flex-col gap-2 ${className}`} {...rest}>
      {showId && <div className={firstLineClassName}>#{id}</div>}
      <div className={secondLineClassName}>
        SO: {number} {po ? `, PO: ${po}` : null}
      </div>

      <div className={customerLineClassName}>{customerName}</div>

      {note !== null && <div className="opacity-70">{note}</div>}
    </div>
  );
}

export default ShipmentTitle;
